// extracted by mini-css-extract-plugin
export default {"checkBoxContainer":"CheckBox_checkBoxContainer__H8ovD","checkBox":"CheckBox_checkBox__K4rJz","inputNormal":"CheckBox_inputNormal__XbRjo","inputEdit":"CheckBox_inputEdit__KVwDe"};